import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import FilterMenu from "./FilterMenu";
import { message } from "antd";
import API from "../../../services/api-request";
import state from "../../../../src/config/valtio/store";
import { useSearchParams } from "react-router-dom";

const UsageTrend = ({ id }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dataQuota, setDataQuota] = useState([]);
  const [dataDate, setDataDate] = useState([]);

  const getDataUsage = async (
    strDate = searchParams.get("strDate"),
    endDate = searchParams.get("endDate"),
    card_id = id ? id : searchParams.get("id") ?? ""
  ) => {
    state.LOADING = true;

    await API.Get(
      `usage-daily?card_id=${card_id}&start_date=${strDate}&end_date=${endDate}`
    )
      .then((result) => {
        let dataTemp = [];

        setDataDate(result.data.date);

        result.data.data_total.forEach((e) => {
          dataTemp.push(parseFloat(e));
        });

        setDataQuota(dataTemp);
      })
      .catch((err) => {
        setDataQuota([]);
        if (id) {
          message.info("Failed Fetch Usage Data!");
        }
      });

    state.LOADING = false;
  };

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Daily Usage Trend",
    },
    xAxis: {
      categories: dataDate.map((date) => {
        const parsedDate = new Date(date);
        return parsedDate.toLocaleDateString("id-ID", {
          month: "short",
          day: "numeric",
        });
      }),
      title: {
        text: "",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Data Usage (MB)",
      },
      stackLabels: {
        enabled: true,
      },
    },
    legend: {
      enabled: true,
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y} MB</b>",
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [
      {
        name: "Data Usage",
        data: dataQuota,
        color: "#f2a442",
      },
    ],
    credits: {
      enabled: false,
    },
  };

  useEffect(() => {
    getDataUsage();
    // eslint-disable-next-line
  }, [id]);

  const handleQuery = (values) => {
    getDataUsage(values.strDate, values.endDate);
  };

  return (
    <>
      <FilterMenu onQueryDate={handleQuery} />

      <HighchartsReact highcharts={Highcharts} options={options} />
    </>
  );
};

export default UsageTrend;
